import { PageSectionsContentSectionContentBlocksPricingCardsPriceCard } from '@/tina/__generated__/types';
import * as stylex from '@stylexjs/stylex';
import { typography } from '../styles/typography';
import { CircleCheck } from './svg/ui-icons';
import '../styles/tokens.stylex';
import { spacing } from '../styles/tokens.stylex';
type HighlightListProps = {
  data: PageSectionsContentSectionContentBlocksPricingCardsPriceCard['tierInclusions'];
  styles?: stylex.StyleXStyles;
};
export const HighlightList = ({
  data,
  styles,
  ...props
}: HighlightListProps) => {
  return <ul {...stylex.props([cardStyles.inclusionsList, styles])} {...props}>
      {data?.map((inc, i) => <li key={`${i}-${inc?.split(' ').join('-')}`} {...stylex.props([typography.body, cardStyles.listItem])}>
          <CircleCheck className="x1c4vz4f x2lah0s xlup9mm x1kky2od" role="presentation" />
          <span>{inc}</span>
        </li>)}
    </ul>;
};
const cardStyles = {
  inclusionsList: {
    kogj98: "x1ghz6dp",
    kmVPX3: "x1717udv",
    kB88ic: "xe8uvvx",
    $$css: true
  },
  listItem: {
    kOIVth: "x16pmaob",
    k8WAf4: "x1tqsu7c",
    kGNEyG: "x6s0dn4",
    k1xSpc: "x78zum5",
    $$css: true
  }
};